module.exports = __webpack_public_path__ + "static/media/Arial-MT.918b7612.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Arial-MT.ttf
// module id = 13
// module chunks = 0